// import React from "react";
// import {
// 	Form,
// 	FormControl,
// 	FormField,
// 	FormItem,
// 	FormLabel,
// 	FormMessage,
// } from "./ui/form";
// import { useForm } from "react-hook-form";
// // import { zodResolver } from "@hookform/resolvers/zod";
// import { Input } from "./ui/input";
// import { Button } from "./ui/button";
// import { ClipLoader } from "react-spinners";
// import { useToast } from "./ui/use-toast";
// import { useMutation } from "react-query";
// import { updateLocation } from "../apis/products";
// import { useEditInternalLocation } from "../hooks/users";
// import { useLocation, useNavigate } from "react-router-dom";

// const LocationForm = ({ locationData, isOnboarding, onComplete }) => {
// 	const { toast } = useToast();
// 	const location = useLocation();
// 	const navigate = useNavigate();

// 	const form = useForm({
// 		// resolver: zodResolver(loginSchema),
// 		defaultValues: {
// 			address: locationData?.address ?? "",
// 			latitude: locationData?.latitude ?? "",
// 			longitude: locationData?.longitude ?? "",
// 			gln: locationData?.gln ?? "",
// 			locationType: locationData?.locationType ?? "",
// 			clientEmail: locationData?.client_email ?? "",
// 		},
// 	});

// 	const { mutate, isLoading } = useMutation(
// 		(variables) => updateLocation(variables),
// 		{
// 			onSuccess() {
// 				toast({
// 					variant: "success",
// 					title: "Success",
// 					description: `Location submitted successfully`,
// 				});
// 				form.reset({
// 					address: "",
// 					latitude: "",
// 					longitude: "",
// 					gln: "",
// 					locationType: "",
// 				});
// 				onComplete();
// 			},
// 			onError(error) {
// 				if (error.code !== "ERR_NETWORK") {
// 					const errorMessage =
// 						error?.response?.data?.message?.includes("parameters")
// 							? "An error occurred, please try again"
// 							: error?.response?.data?.message;
// 					toast({
// 						variant: "destructive",
// 						title: "Error",
// 						description: errorMessage,
// 					});
// 				} else {
// 					console.log(error);
// 					toast({
// 						variant: "destructive",
// 						title: "Error",
// 						description: "Please Check Your Network",
// 					});
// 				}
// 			},
// 		}
// 	);

// 	const { editLocation, isLoading: editingLocation } =
// 		useEditInternalLocation({
// 			onSuccess: () => {
// 				toast({
// 					variant: "success",
// 					title: "Success",
// 					description: `Product Updated Succcessfully`,
// 				});
// 				onComplete();
// 			},
// 			onError: (error) => {
// 				if (error.code === "ERR_NETWORK") {
// 					navigate("/", { state: { from: location }, replace: true });
// 				} else if (
// 					error.response.status === 401 ||
// 					error.response.status === 403
// 				) {
// 					navigate("/", { state: { from: location }, replace: true });
// 				} else {
// 					toast({
// 						variant: "destructive",
// 						title: "Error",
// 						description: `${error?.response?.data?.message}`,
// 					});
// 				}
// 			},
// 		});

// 	function onSubmit(values) {
// 		if (isOnboarding) {
// 			mutate(values);
// 		} else {
// 			editLocation({ values });
// 			onComplete();
// 		}
// 	}

// 	return (
// 		<div className="">
// 			<p className="font-medium text-xl text-primary mb-8">
// 				Update Location
// 			</p>
// 			<Form {...form}>
// 				<form
// 					onSubmit={form.handleSubmit(onSubmit)}
// 					className="space-y-5"
// 					autoComplete="off"
// 				>
// 					<FormField
// 						control={form.control}
// 						name="address"
// 						render={({ field }) => (
// 							<FormItem>
// 								<FormLabel>Full Address</FormLabel>
// 								<FormControl>
// 									<Input
// 										placeholder="enter address here"
// 										{...field}
// 									/>
// 								</FormControl>
// 								<FormMessage />
// 							</FormItem>
// 						)}
// 					/>

// 					<FormField
// 						control={form.control}
// 						name="latitude"
// 						render={({ field }) => (
// 							<FormItem>
// 								<FormLabel>Latitude</FormLabel>
// 								<FormControl>
// 									<Input
// 										placeholder="enter latitude here"
// 										{...field}
// 									/>
// 								</FormControl>
// 								<FormMessage />
// 							</FormItem>
// 						)}
// 					/>
// 					<FormField
// 						control={form.control}
// 						name="longitude"
// 						render={({ field }) => (
// 							<FormItem>
// 								<FormLabel>Longitude</FormLabel>
// 								<FormControl>
// 									<Input
// 										placeholder="enter longitude here"
// 										{...field}
// 									/>
// 								</FormControl>
// 								<FormMessage />
// 							</FormItem>
// 						)}
// 					/>
// 					<FormField
// 						control={form.control}
// 						name="locationType"
// 						render={({ field }) => (
// 							<FormItem>
// 								<FormLabel>Location Type (Optional)</FormLabel>
// 								<FormControl>
// 									<Input
// 										placeholder="enter location type here"
// 										{...field}
// 									/>
// 								</FormControl>
// 								<FormMessage />
// 							</FormItem>
// 						)}
// 					/>
// 					<FormField
// 						control={form.control}
// 						name="gln"
// 						render={({ field }) => (
// 							<FormItem>
// 								<FormLabel>Client Gln</FormLabel>
// 								<FormControl>
// 									<Input
// 										placeholder="enter your gln here"
// 										{...field}
// 										disabled
// 									/>
// 								</FormControl>
// 								<FormMessage />
// 							</FormItem>
// 						)}
// 					/>

// 					<Button
// 						type="submit"
// 						variant=""
// 						disabled={isLoading || editingLocation}
// 					>
// 						{isLoading || editingLocation ? (
// 							<span className="mx-[20px]">
// 								<ClipLoader color="primary" size={20} />
// 							</span>
// 						) : (
// 							<span> Submit</span>
// 						)}
// 					</Button>
// 				</form>
// 			</Form>
// 		</div>
// 	);
// };

// export default LocationForm;





import React from "react";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "./ui/form";
import { useForm } from "react-hook-form";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { ClipLoader } from "react-spinners";
import { useToast } from "./ui/use-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { useEditClientLocation } from "../migration-api/api-hooks/clients";

const LocationForm = ({ locationData, isOnboarding = false, onComplete }) => {
	const { toast } = useToast();
	const location = useLocation();
	const navigate = useNavigate();

	const form = useForm({
		defaultValues: {
			address: locationData?.address ?? "",
			latitude: locationData?.latitude ?? "",
			longitude: locationData?.longitude ?? "",
			gln: locationData?.gln ?? "",
			locationType: locationData?.locationType ?? "",
			clientEmail: locationData?.client_email ?? "",
		},
	});

	// Use the custom hook for editing client location
	const { editClientLocation, isLoading } = useEditClientLocation({
		onSuccess: () => {
			toast({
				variant: "success",
				title: "Success",
				description: isOnboarding 
					? "Location submitted successfully" 
					: "Location updated successfully",
			});

			// Reset form if onboarding
			if (isOnboarding) {
				form.reset({
					address: "",
					latitude: "",
					longitude: "",
					gln: "",
					locationType: "",
				});
			}

			// Call onComplete callback if provided
			if (onComplete) {
				onComplete();
			}
		},
		onError: (error) => {
			if (error.code === "ERR_NETWORK") {
				toast({
					variant: "destructive",
					title: "Error",
					description: "Please check your network connection",
				});
				navigate("/", { state: { from: location }, replace: true });
			} else if (
				error.response?.status === 401 ||
				error.response?.status === 403
			) {
				navigate("/", { state: { from: location }, replace: true });
			} else {
				const errorMessage =
					error?.response?.data?.message?.includes("parameters")
						? "An error occurred, please try again"
						: error?.response?.data?.message || "An error occurred";
				
				toast({
					variant: "destructive",
					title: "Error",
					description: errorMessage,
				});
			}
		},
	});

	function onSubmit(values) {
		const payload = {
			address: values.address,
			latitude: values.latitude,
			longitude: values.longitude,
			gln: values.gln,
			locationType: values.locationType,
			clientEmail: values.clientEmail,
		};

		editClientLocation(payload);
	}

	return (
		<div className="">
			<p className="font-medium text-xl text-primary mb-8">
				{isOnboarding ? "Submit Location" : "Update Location"}
			</p>
			<Form {...form}>
				<form
					onSubmit={form.handleSubmit(onSubmit)}
					className="space-y-5"
					autoComplete="off"
				>
					<FormField
						control={form.control}
						name="address"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Full Address</FormLabel>
								<FormControl>
									<Input
										placeholder="Enter address here"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<FormField
						control={form.control}
						name="latitude"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Latitude</FormLabel>
								<FormControl>
									<Input
										placeholder="Enter latitude here"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<FormField
						control={form.control}
						name="longitude"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Longitude</FormLabel>
								<FormControl>
									<Input
										placeholder="Enter longitude here"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<FormField
						control={form.control}
						name="locationType"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Location Type (Optional)</FormLabel>
								<FormControl>
									<Input
										placeholder="Enter location type here"
										{...field}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<FormField
						control={form.control}
						name="gln"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Client GLN</FormLabel>
								<FormControl>
									<Input
										placeholder="Enter your GLN here"
										{...field}
										disabled
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<Button type="submit" disabled={isLoading}>
						{isLoading ? (
							<span className="flex items-center gap-2">
								<ClipLoader color="white" size={20} />
								{isOnboarding ? "Submitting..." : "Updating..."}
							</span>
						) : (
							<span>Submit</span>
						)}
					</Button>
				</form>
			</Form>
		</div>
	);
};

export default LocationForm;